import AppointmentDetailsPage from "./AppointmentDetailsPage";

export default AppointmentDetailsPage;
